import { Element } from "@craftjs/core";
import { GitCommitHorizontal } from "lucide-react";

import { define, prop } from "@/components/builder/utils";

import { ProgressValueBlock } from "..";
import BasePreview from "../base";

function ProgressBarPreview({ ...props }) {
  return <BasePreview {...props}>
    <div>
      <Element id="progress-value" is={ProgressValueBlock} />
    </div>
  </BasePreview>
}

export default define('progress-bar', ProgressBarPreview)
  .palete(<GitCommitHorizontal size={16} />, 'Progress Bar', 'Embedded')
  .property(prop.predefined.customClass())
  .property(...prop.predefined.appearance())
  .property(...prop.predefined.borders())
  .property(...prop.predefined.layout())
  .defaultProps({
    size: {
      width: 'w-full',
    },
    maxWidth: 'max-w-full',
    border: {
      color: 'gray-300',
      width: {
        border: '1',
      },
      radius: {
        rounded: '3xl',
      },
    },
    background: {
      color: 'gray-200',
    },
  })
  .build()
